import { shouldDismissAdaptiveCard } from '@/helpers/adaptiveCards'

type ActivityAttachment = {
  contentType?: string
}

type WebChatActivity = {
  value?: {
    actionId?: string
    choice?: string
  }
  suggestedActions?: {
    actions?: unknown[]
  }
  attachments?: ActivityAttachment[]
}

type ActivityCallbackResult = {
  hasSuggestedActions: boolean
  hasAdaptiveCard: boolean
}

type ActivityCallbackDeps = {
  sendMessage: (payload: { message: string }) => void
  documentRef?: Document
}

const CONTINUE_CHOICES = [
  "I've completed this, continue my application",
  "I'm having trouble",
  'Continue with payroll check',
] as const

export const handleWebChatActivity = (
  activity: WebChatActivity | null | undefined,
  { sendMessage, documentRef = document }: ActivityCallbackDeps,
): ActivityCallbackResult => {
  let hasSuggestedActions = false
  let hasAdaptiveCard = false

  if (shouldDismissAdaptiveCard(activity)) {
    const adaptiveCards = documentRef.querySelectorAll('div.ac-adaptiveCard')

    if (adaptiveCards.length > 0) {
      const mostRecentCard = adaptiveCards[adaptiveCards.length - 1]
      const activityBody = mostRecentCard.closest(
        '.webchat__basic-transcript__activity-body',
      ) as HTMLElement | null

      if (activityBody) {
        activityBody.style.display = 'none'
      }

      const choice = activity?.value?.choice
      if (
        typeof choice === 'string' &&
        (CONTINUE_CHOICES as readonly string[]).includes(choice)
      ) {
        sendMessage({ message: choice })
      }
    }
  }

  if (
    activity?.suggestedActions?.actions &&
    activity.suggestedActions.actions.length > 0
  ) {
    hasSuggestedActions = true
  }

  if (activity?.attachments && activity.attachments.length > 0) {
    const hasAdaptiveCardInActivity = JSON.parse(
      JSON.stringify(activity.attachments),
    ).find(
      (attachment: ActivityAttachment) =>
        attachment.contentType === 'application/vnd.microsoft.card.adaptive',
    )

    if (hasAdaptiveCardInActivity !== undefined) {
      hasAdaptiveCard = true
    }
  }

  return { hasSuggestedActions, hasAdaptiveCard }
}
